<pcg-resizable-widget>
    <!-- #region Header -->
    <span widget-title>MESSAGES</span>
    <div class="widget-meta" widget-meta>
        <span 
            [class]="showUnreadOnly() ? 'btn-ghost all-button' : 'pill pill-unread'"
            (click)="setUnreadFilter(false)"
        >All</span>
        <span 
            [class]="showUnreadOnly() ? 'pill pill-unread' : 'btn-ghost all-button'"
            (click)="setUnreadFilter(true)"
        >
            <span class="pill-dot"></span>{{ unreadCount() }} Unread
        </span>
        @if(userModules().length > 1) {
            <ng-container *ngTemplateOutlet='baDropDown'></ng-container>
        }
    </div>
    <!-- #endregion -->

    <!-- #region Subheader -->
    <div class="widget-toolbar" widget-subheader>
        <button 
            class="toolbar-link" 
            (click)="markAllAsRead()"
        >
            <svg 
                width="11" 
                height="11" 
                viewBox="0 0 16 16" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2"
            >
                <path d="M2 8l4 4 8-8"/>
            </svg>
            Mark all read
        </button>
        <button 
            class="icon-btn" 
            title="Delete all" 
            (click)="deleteAllNotifications()"
        >
            <svg 
                viewBox="0 0 16 16" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="1.8"
            >
                <path d="M3 4h10M6 4V3h4v1M5 4v8a1 1 0 001 1h4a1 1 0 001-1V4"/>
            </svg>
        </button>
        <button 
            class="icon-btn" 
            title="Settings"
            (click)="navToSettings()"
        >
            <svg 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="1.8"
            >
                <circle 
                    cx="12" 
                    cy="12" 
                    r="3"
                />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
        </button>
    </div>
    <!-- #endregion -->

    <!-- #region Body -->
    <div 
        class="widget-body h-100" 
        (scroll)="onScroll($event)"
        widget-body
    >
        @if (isLoading()) {
            <div class="mt-2 pb-1 text-center">
                <span 
                    class="spinner-border spinner-border-sm align-middle mr-1" 
                    role="status" 
                    aria-hidden="true"
                ></span>
                Finding Messages...
            </div>
        } @else {
            @for (notification of filteredNotifications(); track notification.userNotificationId) {
                <div 
                    class="notif-item unread" 
                    (click)="onClickNotification(notification);"
                >
                    <div 
                        class="notif-icon"
                        [style.color]="baService.getIconStyleByBusinessArea(notification.businessArea).color"
                        [style.background-color]="baService.getIconStyleByBusinessArea(notification.businessArea).background"
                    >
                        <fa-icon [icon]="baService.getIconByBusinessArea(notification.businessArea)"></fa-icon>
                    </div>

                    <div class="notif-body">
                        <div class="notif-title">{{ notification.title }}</div>
                        <div class="notif-desc" data-dd-privacy="mask">
                            @if (notification.isEncrypted) {
                                <fa-icon
                                    class="me-1 text-muted"
                                    [icon]="faLock"
                                    ngbTooltip="This message is protected. Open the record to read it."
                                    container="body"
                                    placement="top" />
                            }
                            {{ notification.message }}
                        </div>
                    </div>
                    <div class="notif-right">
                    @if (!notification.markedAsRead) { <div class="unread-dot"></div> } 
                    <div class="notif-time">{{ notification.notifiedDate | utcToLocal | timeAgo }}</div>
                    </div>
                </div>
            } @empty {
                <div class="text-center text-muted py-3">No notifications to display</div>
            }
        }
    </div>
    <!-- #endregion -->
</pcg-resizable-widget>

<!-- #region Business Area Filter -->
<ng-template #baDropDown>
    <div 
        ngbDropdown 
        placement="bottom-end"
    >
        <button 
            class="icon-btn remove-dropdown-arrow" 
            title="Filter"
            ngbDropdownToggle
        >
            <svg 
                viewBox="0 0 16 16" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="1.8"
            >
                <path d="M2 4h12M4 8h8M6 12h4"/>
            </svg>
        </button>
        <div 
            class="filter-dropdown" 
            ngbDropdownMenu
        >
            @for (businessArea of userModules(); track businessArea) {
                <button 
                    class="btn btn-sm rounded-0 col-4" 
                    (click)="toggleBusinessArea(businessArea)"
                    [class.text-secondary]="!selectedBusinessAreas().includes(businessArea)"
                    [ngbTooltip]="toDescription(businessArea)"
                    [style.color]="selectedBusinessAreas().includes(businessArea) ? baService.getIconStyleByBusinessArea(businessArea).background : null"
                >
                    <fa-icon [icon]="baService.getIconByBusinessArea(businessArea)"/>
                </button>
            }
            <div class="col-12 text-center mt-1">
                @if(selectedBusinessAreas()?.length > 0) {
                    <button 
                        class="btn btn-outline-primary" 
                        (click)="selectedBusinessAreas.set([])">
                        Clear
                    </button>
                }
            </div>
        </div>
    </div>
</ng-template>
<!-- #endregion -->

<!-- #region Dropdown + Mark as read -->
<ng-template 
    #dropDown 
    let-notification="notification"
>
    <div 
        class="d-flex align-items-center" 
        (click)="$event.stopPropagation()"
    >
        @if (!notification.markedAsRead) {
            <span 
                class="btn-primary unread-dot mr-1" 
                (click)="markAsRead(notification)"
            ></span>
        }
        <div 
            class="dropdown" 
            ngbDropdown 
            placement="bottom-right"
        >
            <button 
                class="btn btn-link p-0 menu-toggle remove-dropdown-arrow" 
                ngbDropdownToggle
            >
                <i class="menu-triangle"></i>
            </button>
            <div 
                class="dropdown-menu" 
                ngbDropdownMenu
            >
                @if (!notification.markedAsRead) {
                    <button 
                        ngbDropdownItem 
                        (click)="markAsRead(notification)"
                    >
                        Mark as read
                    </button>
                    <button 
                        ngbDropdownItem 
                        (click)="unsubscribe(notification)"
                        [class.text-secondary]="!notification.subscription"
                    >
                        Unsubscribe                     
                    </button>
                }
                <button 
                    ngbDropdownItem 
                    (click)="navigateToLink($safeNavigationMigration(notification?.link))"
                >
                    View Details
                </button>
                <button 
                    ngbDropdownItem 
                    (click)="deleteNotification(notification)"
                >
                    Delete
                </button>
            </div>
        </div>
    </div>
</ng-template>
<!-- #endregion -->